import { render } from "./FormDescarga.vue?vue&type=template&id=5527561d&scoped=true"
import script from "./FormDescarga.vue?vue&type=script&lang=js"
export * from "./FormDescarga.vue?vue&type=script&lang=js"

import "./FormDescarga.vue?vue&type=style&index=0&id=5527561d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5527561d"

export default script